import React from "react"
import PropTypes from "prop-types"
import { Button } from "../components/styled"
import AnalyticsService from "../utils/AnalyticsService"

export const DropDownComponent  = ({disable, itemDropText}) =>  {
  const sendEventAnalytic = (loginType) => {
    return AnalyticsService.sendGa4Event({event: 'Promotions' , trigger: loginType, category: "Landing", action: 'siriusxm',  label: "continue"})
  }

  return (
    <div className="col-md-6">
            <div className="dropdown">
              <Button className="btn-primary1 dropdown-toggle" disable={disable}  type="button" data-toggle="dropdown" aria-expanded="false" style={{"marginBottom": "15px"}}>
              {itemDropText[0]}
              </Button>
              <div className="dropdown-menu">
                <a className="dropdown-item" href={process.env.REACT_APP_TMO_ID_AUTH_URL} onClick={() => sendEventAnalytic('Current-Tmo')} >{itemDropText[1]}</a>
                <a className="dropdown-item" href={process.env.REACT_APP_TMO_TFB_ID_AUTH_URL} onClick={() => sendEventAnalytic('Tmo_for_BC') } >{itemDropText[2]}</a>
              </div>
            </div>
          </div>
  );
}


DropDownComponent.propTypes = {
    itemDropText: PropTypes.array,
  }